import {createRoot} from 'react-dom/client'
// Axios
import axios from 'axios'
import {QueryClient, QueryClientProvider} from 'react-query'
import {ReactQueryDevtools} from 'react-query/devtools'
// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'
import SetupContextProvider from './app/constructor/helpers/SetupContext'
import React from 'react'
import {ThemeProvider} from './app/constructor/helpers/ThemeContext'
import {initApiUrl} from './app/api'
import {BrowserRouter} from 'react-router-dom'
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios)

const queryClient = new QueryClient()
const container = document.getElementById('root')
initApiUrl().then(() => {
    if (container) {
        createRoot(container).render(
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <QueryClientProvider client={queryClient}>
                    <SetupContextProvider>
                        <MetronicI18nProvider>
                            <ThemeProvider>
                                <AuthProvider>
                                    <AppRoutes />
                                </AuthProvider>
                            </ThemeProvider>
                        </MetronicI18nProvider>
                        <ReactQueryDevtools initialIsOpen={false} />
                    </SetupContextProvider>
                </QueryClientProvider>
            </BrowserRouter>
        )
    }
})
